module.exports = __webpack_public_path__ + "cc.svg?141b04facc5c31aca87df26ea050e4db";